import { parseError } from '../../libs/parser';
import { useTranslation } from 'react-i18next';
import Context from '../../provider';
import React, { useContext, useEffect, useState } from 'react';
import memberApi from '../../libs/api/memberApi';
import './index.scss';

export default function LogoFooterComponent() {
  const { t } = useTranslation();

  const { init, dispatch, lang, isMobile } = useContext(Context);

  const [mediaIcons, setMediaIcons] = useState([]);
  const [foundIcons, setFoundIcons] = useState([]);
  const [ofIcons, setOfIcons] = useState([]);
  const [spIcons, setSpIcons] = useState([]);

  useEffect(() => {
    if (init) {
      fetchIconsData(1);
    }
  }, [init]);

  const fetchIconsData = async (page) => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const response = await memberApi.getIcons({
        page,
        pageSize: 1000
      });

      setMediaIcons([...(response?.list ?? []).filter((d) => d.uri_name.includes('icons-medias') )]);
      setFoundIcons([...(response?.list ?? []).filter((d) => d.uri_name.includes('icons-founding-members') )]);
      setOfIcons([...(response?.list ?? []).filter((d) => d.uri_name.includes('icons-member-of') )]);
      setSpIcons([...(response?.list ?? []).filter((d) => d.uri_name.includes('icons-specials') )]);

    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  const footerStyle = () => {
    let style = {};
    if (isMobile) {
      style = {
        padding: '2rem 2rem 14.75rem 2rem'
      };

    } else {
      style = {
        padding: '2rem 6.5rem'
      };
    }
    return style;
  };

  const socialStyle = () => {
    let style = {};
    if (!isMobile) {
      style = {
        justifyContent: 'flex-start',
        gap: '0.75rem'
      };
    }
    return style;
  };

  const foundLogoStyle = () => {
    let style = {};
    if (!isMobile) {
      style = {
        justifyContent: 'flex-start',
        padding: '0rem 0.25rem'
      };
    }
    return style;
  };

  const descStyle = () => {
    let style = {};
    if (!isMobile) {
      style = {
        width: 'max-content'
      };
    }
    return style;
  };

  const imgLoadHandler = (e) => {
    const width = e.target.naturalWidth;
    const height = e.target.naturalHeight;
    // console.log(`mediaIcons-${index} : ${width}x${height}`);
    e.target.style.width = `${width/32}rem`;
    e.target.style.height = `${height/32}rem`;
  };

  return (
    <div className={`${ isMobile ? '' : 'web-max-container ' }logo-footer`} style={footerStyle()}>
      {mediaIcons.length > 0 && (
        <div className="social-bar" style={socialStyle()}>
          <div className="title" style={{ fontWeight: isMobile ? '500' : '700' }}>
            { t('footer.followUs') }
          </div>
          <div className="logos-cont">
            {mediaIcons.map((item, index) => {
              return (
                <img
                  key={`mediaIcons-${index}`}
                  alt='logo'
                  className="logo-btn logo"
                  src={item.cover?.[lang]}
                  onLoad={(e) => {
                    e.stopPropagation();
                    imgLoadHandler(e);
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.external_url && item.external_url?.[lang]) {
                      window.open(item.external_url?.[lang]);
                    }
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
      {foundIcons.length > 0 && (
        <div className="founding-members-cont">
          <div className="title" style={{ fontWeight: isMobile ? '500' : '700' }}>
            { t('footer.foundingMembers') }
          </div>
          <div className="logos-cont" style={foundLogoStyle()}>
            {foundIcons.map((item, index) => {
              return (
                <img
                  key={`foundIcons-${index}`}
                  alt='logo'
                  className={`${ isMobile ? 'mobile' : 'web' }-logo-${index + 1} logo`}
                  src={item.cover?.[lang]}
                  onLoad={(e) => {
                    e.stopPropagation();
                    imgLoadHandler(e);
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.external_url && item.external_url?.[lang]) {
                      window.open(item.external_url?.[lang]);
                    }
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
      {ofIcons.length > 0 && (
        <div className="members-cont">
          <div className="title" style={{ fontWeight: isMobile ? '500' : '700' }}>
            { t('footer.memberOf') }
          </div>
          <div className="logos-cont" style={foundLogoStyle()}>
            {ofIcons.map((item, index) => {
              return (
                <img
                  key={`ofIcons-${index}`}
                  alt='logo'
                  className={`${ isMobile ? 'mobile' : 'web' }-logo-${index + 1} logo`}
                  src={item.cover?.[lang]}
                  onLoad={(e) => {
                    e.stopPropagation();
                    imgLoadHandler(e);
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.external_url && item.external_url?.[lang]) {
                      window.open(item.external_url?.[lang]);
                    }
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
      {spIcons.length > 0 && (
        <div className="members-cont">
          <div className="logos-cont" style={foundLogoStyle()}>
            {spIcons.map((item, index) => {
              return (
                <img
                  key={`spIcons-${index}`}
                  alt='logo'
                  className={`${ isMobile ? 'mobile' : 'web' }-logo-${index + 1} logo`}
                  src={item.cover?.[lang]}
                  onLoad={(e) => {
                    e.stopPropagation();
                    imgLoadHandler(e);
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.external_url && item.external_url?.[lang]) {
                      window.open(item.external_url?.[lang]);
                    }
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
      <div className="footer-desc" style={descStyle()}>
        {t('footer.copyright', { year: new Date().getFullYear() })}
      </div>
      <div className="footer-desc" style={{ height: '10rem' }} />
    </div>
  );
}